

import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"

const Container = styled.div`
  font-weight: var(--font-weight-sm);
  font-size: var(--font-size-sm);
  color: ${({theme}) => theme.mainTextColor};

  h4{
    font-weight: var(--font-weight-lg);
    font-size: var(--font-size-sm);
    color: ${({theme}) => theme.mainTextColor};
  }

.list{
  display: flex;
  flex-direction: column;
  margin: 10px 0 20px 30px;
  width: 70%;
  gap: 10px;

  .list-item{
    display: flex;
    flex-direction: column;
  }

  .paketleme-list-item{
    display: flex;
    margin-block: 5px;
    .paketleme-left{
      display: flex;
      align-items: center;
      min-width: 200px;
    }
    p{
        span{
        margin-inline: 5px;
        }
    }

    .paketleme-name{
      padding-right: 5px;
    }

    .paketleme-quantity{
      padding-left: 5px;
    }
  }
}

  .seperator{
    width: 100%;
    height: 1px;
    background-color: ${({theme}) => theme.contrastBorderColor};
  }
`


const YukDetails = ({yukData, paketlemeData}) => {
  return (
    <Container>
        <h4 className="title">Yük</h4>
        <div className="list">
            {
                yukData?.yuklemeTuru?.text &&
                <div className="list-item">{yukData?.yuklemeTuru?.text}</div>
            }
            {
                yukData?.yukTuru &&
                <div className="list-item">{yukData?.yukTuru}</div>
            }
            {
                (yukData?.toplamAgirlik || yukData?.agirlikBirim?.text || yukData?.toplamHacim) &&
                <div className="list-item">{yukData?.agirlikBirim?.value !== 3 && yukData?.toplamAgirlik} {yukData?.agirlikBirim?.text}{(yukData?.agirlikBirim?.text && yukData?.toplamHacim) && "/"}{yukData?.toplamHacim &&  `${yukData?.toplamHacim} Metreküp`}</div>
            }
            {
                paketlemeData?.length > 0 &&
                    paketlemeData?.map((item,index) => {
                      const adjustedIndex = index + 1;
                      return (
                      <div>
                      <div className="paketleme-index">{adjustedIndex}. paketleme</div>
                        {
                          item?.list?.map((subItem) => (
                            <div className="paketleme-list-item">
                              <div className="paketleme-left">
                                <p className="paketleme-name">{item?.paketlemeType}</p>
                                (
                                  <p>{subItem?.en || ""}</p>
                                  <p>{(( subItem?.en || "") && (subItem?.boy || "")) && <span>x</span> }{subItem?.boy || ""}</p>
                                  <p>{(( subItem?.boy || "") && (subItem?.yukseklik || "")) && <span>x</span>}{subItem?.yukseklik || ""}</p>
                                  <p><span>x</span>{subItem?.agirlik || ""}</p>
                                )
                              </div>
                                  <p className="paketleme-quantity">{subItem?.sayisi || ""}{(subItem?.sayisi || "") && " adet"}</p>
                            </div>
                          ))
                        }
                      </div>
                    )})
            }
            {
                yukData?.yukunDegeri &&
                <div className="list-item">{yukData?.yukunDegeri && `Sigorta Değeri ${formatConverter(yukData?.yukunDegeri, 0)} TL`}</div>
            }
            {
                yukData?.yukDesc &&
                <div className="list-item">{yukData?.yukDesc}</div>
            }
        </div>
        <div className="seperator"/>
 </Container>
  )
}

export default YukDetails